export const isListingDetail = route => route === 'listing_detail'
